export default "__VITE_ASSET__nvq2Le8z__"